module.exports = __webpack_public_path__ + "img/logo-full.d282364c.png";